import {IRecommendationShort} from "../../../services/models/recommendation";
import s from "./recommendation.module.css";
import sButtons from "../../../assets/styles/buttons.module.css";
import React from "react";

interface SectorCardProps {
    recommendation: IRecommendationShort,
    handleLinkClick: (id: string) => void,
}

const RecommendationCard = ({recommendation, handleLinkClick}: SectorCardProps) => {

    return (
        <div className={`d-flex flex-column ${s.wrapper}`}>
            <div className={s.content}>
                <div className={s.header}>
                    <div className={s.infoBlock}>
                        <div className={s.roleWrapper}>
                            <p className={s.role}>
                                {recommendation.status}
                            </p>
                        </div>
                    </div>
                </div>
                <h3 className={s.title}>{recommendation.name}</h3>
            </div>

            <div className={s.buttons}>
                <button
                    onClick={() => handleLinkClick(recommendation._id)}
                    className={`${sButtons.iconButton} ${s.button} ${sButtons.redirectButtonRight}`}
                >
                    {recommendation.unreadCommentsCount !== 0 && (
                        <span className={s.unreadCount}>{recommendation.unreadCommentsCount}</span>
                    )}
                    <span>Перейти</span>
                </button>
            </div>
        </div>
    );
}

export default RecommendationCard